// Shared agenda used by K-2, 3-5, and 6-8 pages
export const STANDARD_AGENDA = [
  { time: "7:30-8:30 am", label: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment" },
  { time: "8:30-9:15 am", label: "Keynote Speaker" },
  { time: "9:30-10:30 am", label: "Session 1" },
  { time: "10:45-11:45 am", label: "Session 2" },
  { time: "11:45 am - 1 pm", label: "Lunch" },
  { time: "1:15-2:15 pm", label: "Session 3" },
];
